import InsuranceClaimsWorkspace from "components/Insurance/InsuranceClaimsWorkspace";
import InsuranceCountyPracticeWorkspace from "components/Insurance/InsuranceCountyPracticeWorkspace";
import InsurancePlanClaimEditWorkspace from "components/Insurance/InsurancePlanClaimEditWorkspace";
import InsuranceScenarioWorkspace from "components/Insurance/InsuranceScenarioWorkspace";
import InsuranceSummaryWorkspace from "components/Insurance/InsuranceSummaryWorkspace";
import RouteLayout, { RouteErrorLayout } from "components/Menu/components/RouteLayout";

export const insuranceRoutes = [
  {
    path: "/insurance",
    element: <RouteLayout />,
    children: [{ index: true, element: <InsuranceSummaryWorkspace /> }],
    errorElement: <RouteErrorLayout errorTitle="Insurance" />,
  },
  {
    path: "/insurance/claims",
    element: <RouteLayout />,
    children: [{ index: true, element: <InsuranceClaimsWorkspace /> }],
    errorElement: <RouteErrorLayout errorTitle="Insurance" />,
  },
  {
    path: "/insurance/claims/:insurance_claim_id",
    element: <RouteLayout />,
    children: [{ index: true, element: <InsurancePlanClaimEditWorkspace /> }],
    errorElement: <RouteErrorLayout errorTitle="Insurance" />,
  },
  {
    path: "/insurance/:insurance_scenario_id",
    element: <RouteLayout />,
    children: [{ index: true, element: <InsuranceCountyPracticeWorkspace /> }],
    errorElement: <RouteErrorLayout errorTitle="Insurance" />,
  },
  {
    path: "/insurance/:insurance_scenario_id/:state_name/:county_name/:commodity_name/:type_name/:practice_name",
    element: <RouteLayout />,
    children: [{ index: true, element: <InsuranceScenarioWorkspace /> }],
    errorElement: <RouteErrorLayout errorTitle="Insurance" />,
  },
];
